<template>
  <div class="content-inclusive-content" id="identidade-verbal-conteudo-inclusiva" data-search-anchor>
    <div class="content-inclusive-wrapper">
      <h1 class="content-inclusive-title">{{ contentInclusiveTitle }}</h1>
    </div>
    <div class="content-inclusive-description-wrapper">
      <div class="column-red">
        <div class="content-inclusive-column-red">
          <p class="content-inclusive-text">{{ contentInclusiveText }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCancel />
          <p class="content-inclusive-description-icon">{{ contentInclusiveDescription }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCancel />
          <p class="content-inclusive-description-icon">{{ contentInclusiveDescription1 }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCancel />
          <p class="content-inclusive-description-icon">{{ contentInclusiveDescription2 }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCancel />
          <p class="content-inclusive-description-icon">{{ contentInclusiveDescription3 }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCancel />
          <p class="content-inclusive-description-icon">{{ contentInclusiveDescription4 }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCancel />
          <p class="content-inclusive-description-icon">{{ contentInclusiveDescription5 }}</p>
        </div>
      </div>

      <div class="column green">
        <div class="content-inclusive-column-green">
          <p class="content-inclusive-text">{{ contentInclusiveText1 }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCheck />
          <p class="content-inclusive-description-icon">{{ contentInclusiveDescription6 }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCheck />
          <p class="content-inclusive-description-icon">{{ contentInclusiveDescription7 }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCheck />
          <p class="content-inclusive-description-icon">{{ contentInclusiveDescription8 }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCheck />
          <p class="content-inclusive-description-icon">{{ contentInclusiveDescription9 }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCheck />
          <p class="content-inclusive-description-icon">{{ contentInclusiveDescription10 }}</p>
        </div>

        <div class="icon-wrapper">
          <IconCheck />
          <p class="content-inclusive-description-icon">{{ contentInclusiveDescription11 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import IconCancel from '@/assets/icons/IconCancel.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import ContentPageMixin from '@/mixins/content-page-mixin'
import { ContentPageStore } from '@/store/verbal-identity-page/content-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck, IconCancel } })
export default class ContentInclusiveSection extends Mixins(ContentPageMixin) {
  contentPageStore: PageStoreContract = getModule(ContentPageStore, this.$store)

  get contentInclusiveTitle(): string {
    return this.getElementTitle(4, 0)
  }

   get contentInclusiveText(): string {
    return this.getElementText(4, 1)
  }

  get contentInclusiveDescription(): string {
    return this.getElementText(4, 2)
  }

  get contentInclusiveDescription1(): string {
    return this.getElementText(4, 3)
  }

  get contentInclusiveDescription2(): string {
    return this.getElementText(4, 4)
  }

  get contentInclusiveDescription3(): string {
    return this.getElementText(4, 5)
  }

  get contentInclusiveDescription4(): string {
    return this.getElementText(4, 6)
  }

  get contentInclusiveDescription5(): string {
    return this.getElementText(4, 7)
  }

  get contentInclusiveText1(): string {
    return this.getElementText(4, 8)
  }

  get contentInclusiveDescription6(): string {
    return this.getElementText(4, 9)
  }

   get contentInclusiveDescription7(): string {
    return this.getElementText(4, 10)
  }

   get contentInclusiveDescription8(): string {
    return this.getElementText(4, 11)
  }

   get contentInclusiveDescription9(): string {
    return this.getElementText(4, 12)
  }

   get contentInclusiveDescription10(): string {
    return this.getElementText(4, 13)
  }

   get contentInclusiveDescription11(): string {
    return this.getElementText(4, 14)
  }

  async getContentPage(): Promise<void> {
    await this.contentPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.contentPageStore.isLoading) {
      await this.getContentPage()
    }
  }
}
</script>

<style lang="scss">
.content-inclusive-content {
  display: flex;
  flex-direction: column;
  align-items:initial;

  
  width: 1032px;
}



.content-inclusive-column-red,
.content-inclusive-column-green {
  display: block;
  align-items: center;
  padding-top: 97px;
}

.column-red {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.column-green {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 0;
}


.content-inclusive-title {
  font-size: 56px;
  font-weight: 400;
  line-height: 60px;
  letter-spacing: -0.01em;
  text-align: left;
  margin: 0;
}

.content-inclusive-text {
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-top: 0px;
}

.content-inclusive-description-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: 25% 75%;
}

.content-inclusive-description-icon,
.content-inclusive-description {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  padding-left: 7px;
  white-space: pre-line;
}

.content-inclusive-description {
  padding-left: 0;
  width: 430px;
}

.content-inclusive-card-item {
  position: relative;
  max-width: 1032px;
  width: 100%;
  height: 580px;
  border-radius: 12px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-top: 73.94px;
}

.icon-wrapper {
  padding-left: 0 !important;
  padding-bottom: 0 !important;
}

</style>
